import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { PackingMaterialPricesRequest } from "./packing-material-prices-request";

export class PackingMaterialPricesResponseModel extends GlobalResponseObject{
    data?:PackingMaterialPricesRequest[]
     
    constructor(status:boolean, intelCode:number, internalMessage:string ,data?:PackingMaterialPricesRequest[]){
    super(status,intelCode,internalMessage)
    this.status=status
    this.intlCode=intelCode
    this.internalMessage=internalMessage
    this.data=data
    }

}